const actions = {
  RESET_REDUCER: 'RESET_REDUCER',
  SET_CLIENTS:'SET_CLIENTS',
  SET_THERAPIST:'SET_THERAPIST',
  SET_TIMEZONE:'SET_TIMEZONE',
  SET_TEAM_MEMBER:'SET_TEAM_MEMBER',
  SET_INSURANCE_SETTING:'SET_INSURANCE_SETTING',
  SET_BILLING_SETTING:'SET_BILLING_SETTING',
  SET_PRACTICE_DETAILS:'SET_PRACTICE_DETAILS',
  resetData: () =>({
    type:actions.RESET_REDUCER,
  }),
  setClients: (payload)=>({
    type:actions.SET_CLIENTS,
    payload
  }),
  setTherapist: (payload)=>({
    type:actions.SET_THERAPIST,
    payload
  }),
  setTimeZone: (payload)=>({
    type:actions.SET_TIMEZONE,
    payload
  }),
  setTeamMember: (payload)=>({
    type:actions.SET_TEAM_MEMBER,
    payload
  }),
  setInsuranceSetting: (payload)=>({
    type:actions.SET_INSURANCE_SETTING,
    payload
  }),
  setPracticeDetails: (payload)=>({
    type:actions.SET_PRACTICE_DETAILS,
    payload
  }),
  setBillingSetting: (payload)=>({
    type:actions.SET_BILLING_SETTING,
    payload
  }),
};

export default actions;
